<template>
  <div class="small-tips">
    <el-popover :placement="placement" :trigger="trigger" :visible-arrow="visibleArrow" :width="width" :title="title" @show="show" @hide="hide">
      <slot name="contentHtml" />
      <i v-if="ifDefaultReference" slot="reference" class="el-icon-info" style="color:#606266;margin-right:10px"></i>
      <div v-if="!ifDefaultReference" slot="reference" style="display:inline-block">
        <slot name="referenceWay"></slot>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'SmallTips',
  components: {},
  props: {
    //悬浮框触发方式   默认hover
    trigger: { String, default: 'hover' },
    //悬浮框出现的位置  默认top
    placement: { String, default: 'top' },
    //触发显示悬浮框的HTML元素   默认是感叹号图标
    ifDefaultReference: { Boolean, default: true },
    //是否显示悬浮框的箭头
    visibleArrow: { Boolean, default: true },
    //悬浮框的宽度  单位px
    width: { Number, default: 150 },
    //标题
    title: { String, default: '' }
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    //显示是触发
    show() {
      this.$emit('show')
    },
    //隐藏时触发
    hide() {
      this.$emit('hide')
    },
  }
}
</script>

<style scoped lang="less"></style>
